export const FileSettings = {
    MaxNbUploads: "Profile Max Number of Uploads",
    MaxFileSize: "Opportunity Max File Size (in MB)"
  };